// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Receipt from '../components/Receipt/Receipt';
import {actions as OrderAction} from '../duck';
import {actions as ReviewsAction} from '../../marketing/reviews/duck';
import {actions as PaymentMethodsActions} from '../../configure/payment-method/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    order: state.order.order,
    isFetching: state.order.isFetching,
    store: state.store.store,
    paymentMethod: state.paymentMethodConfig.paymentMethod,
    information: state.ui.storeInformation,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...OrderAction,
        ...ReviewsAction,
        ...PaymentMethodsActions,
      },
      dispatch
    )
)(Receipt);
